// apps/configurator/src/lib/catalog.ts
import { MasterRoseAdapter, SerializedCatalog, catalogJson } from '@gorampe/catalog-adapter';

export async function loadCatalog() {
  const adapter = new MasterRoseAdapter(catalogJson as unknown as SerializedCatalog);
  return adapter.load();
}
